module.exports = __webpack_public_path__ + "static/media/rank-1.3091fb57.png";